import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify.js';
// @ts-ignore
import VueExcelViewer from '@uublue/vue-excel-viewer';
import '@uublue/vue-excel-viewer/lib/vue-excel-viewer.css';
import { plugin } from '@ifr/form-questionnaire';
Vue.use(plugin);
Vue.use(VueExcelViewer);

import {AxiosStatic} from "axios";
declare module 'vue/types/vue' {
    interface Vue {
        $axios: AxiosStatic;
    }
}
import {axios} from '@/plugins/http-axios.js';
import moment from "moment";
import polyfills from "@/plugins/polyfills.js";

moment.locale('ru');
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
Vue.prototype.$vuetify = vuetify;
Vue.config.productionTip = false;

if (process.env.NODE_ENV == 'production') {
    Vue.config.errorHandler = function(e, vm, info) {
        e.name = info + ' ' + e.name;
        vm.$store.dispatch('setError', e);
    };
}

Vue.config.warnHandler = function(msg, vm, trace) {
    vm.$store.dispatch('setError', new Error(msg));
    console.error(msg+trace);
};

new Vue({
    router,
    store,
    vuetify,
    beforeCreate(){
        polyfills();
    },
    render: h => h(App),
}).$mount('#app');
